import operatorList from "./operatorList";

export default function filterOperators(type: string) {
  if (type === "string") {
    return operatorList.string;
  }
  if (type === "number") {
    return operatorList.number;
  }
  return [];
}
